"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomCloseButton = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var properties = _ref.properties,
      closeToast = _ref.closeToast;
  if (!properties.closeButton) return null;
  var classes = ['HoiPoi__ToastCloseButton'];
  if (properties.closeButtonClassName) classes.push(properties.closeButtonClassName);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' '),
    onClick: closeToast
  }, properties.closeButton);
});
process.env.NODE_ENV !== "production" ? CustomCloseButton.propTypes = {
  customCloseButton: _propTypes.default.element,
  closeToast: _propTypes.default.func
} : void 0;
var _default = CustomCloseButton;
exports.default = _default;